class CollectionFilters extends HTMLElement {
  constructor () {
    super()
    this.filtersForm = document.querySelector('form[data-name="filters-form"]')
    this.filterCheckboxes = this.querySelectorAll('[data-name="filter-checkbox"]')
    this.filters = this.querySelectorAll('.clc-FilterItem')
    this.form = this.querySelector('form[data-name="filters-form"]')
  }

  connectedCallback () {
    this.init()
  }

  init () {
    this.form.addEventListener('input', (e) => this.updateFilters(e))
  }

  updateFilters (e) {
    e?.preventDefault()
    const formData = new FormData(this.form)

    const filteredFormData = new FormData()
    for (const [key, value] of formData.entries()) {
      if (value !== '' && value !== null && value !== undefined) {
        filteredFormData.append(key, value)
      }
    }

    this.fetchFilteredProducts(filteredFormData)
  }

  async fetchFilteredProducts (formData) {
    const sectionElement = document.querySelector('.sec-Collection')
    const sectionId = sectionElement.dataset.sectionId

    const currentUrl = new URL(window.location.href)
    const basePath = currentUrl.pathname

    const fetchParams = new URLSearchParams()
    fetchParams.append('sections', sectionId)

    for (const [key, value] of formData.entries()) {
      fetchParams.append(key, value)
    }

    const fetchUrl = `${basePath}?${fetchParams.toString()}`

    const urlParams = new URLSearchParams()

    for (const [key, value] of formData.entries()) {
      urlParams.append(key, value)
    }

    const newUrl = urlParams.toString()
      ? `${basePath}?${urlParams.toString()}`
      : basePath

    window.history.pushState({ path: newUrl }, '', newUrl)

    try {
      const response = await fetch(fetchUrl)
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const data = await response.json()
      const dom = new DOMParser()
      const doc = dom.parseFromString(data[sectionId], 'text/html')
      sectionElement.innerHTML = doc.querySelector('.sec-Collection').innerHTML

      this.reinitializeComponents()
    } catch (error) {
      console.error('Error loading products:', error)
    }
  }

  reinitializeComponents () {
    const priceRanges = document.querySelectorAll('price-range')
    if (priceRanges.length) {
      priceRanges.forEach(range => {
        if (typeof range.initialize === 'function') {
          range.initialize()
        }
      })
    }
  }
}

if (!customElements.get('collection-filters')) {
  customElements.define('collection-filters', CollectionFilters)
}
